<template>
  <v-card outlined class="pa-2 mx-4 mb-6 elevation-0">
    <v-row>
      <v-col cols="3">
        <v-col cols="12">
          <h2>Giảng viên</h2>
        </v-col>
      </v-col>
      <v-col cols="9" class="pb-0">
        <v-row class="mx-4 mt-4 mb-0 ml-0 pb-0 justify-end">
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #fff9d0"
            >
              <div style="font-size: 24px"><strong>115</strong></div>
              <div class="text-caption"><strong>Giáo viên</strong></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3"> </v-col>
      <v-col cols="9">
        <v-row class="ma-4 ml-0 justify-end">
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0"> </v-col>
          <v-col class="mr-4 pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #fec7b4"
            >
              <div style="font-size: 24px"><strong>25</strong></div>
              <div class="text-caption"><strong>Thỉnh giảng</strong></div>
            </v-card>
          </v-col>
          <v-col class="mr-4 pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #ffb4c2"
            >
              <div style="font-size: 24px"><strong>40</strong></div>
              <div class="text-caption"><strong>Biên chế</strong></div>
            </v-card>
          </v-col>
          <v-col class="pa-0">
            <v-card
              class="border-radius-8 d-flex flex-column align-end elevation-0 pa-4"
              style="background-color: #b1afff"
            >
              <div style="font-size: 24px"><strong>50</strong></div>
              <div class="text-caption"><strong>Hợp đồng</strong></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {}
</script>

<style></style>
